'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Time = function () {
    function Time(player) {
        _classCallCheck(this, Time);
        this.player = player;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        this.types = [
            'loading',
            'progress',
            'info',
            'fps'
        ];
        this.init();
    }
    _createClass(Time, [
        {
            key: 'init',
            value: function init() {
                for (var i = 0; i < this.types.length; i++) {
                    var type = this.types[i];
                    if (type !== 'fps') {
                        this['init' + type + 'Checker']();
                    }
                }
            }
        },
        {
            key: 'initloadingChecker',
            value: function initloadingChecker() {
                var _this = this;
                var lastPlayPos = 0;
                var currentPlayPos = 0;
                var bufferingDetected = false;
                this.loadingChecker = setInterval(function () {
                    if (_this.enableloadingChecker) {
                        currentPlayPos = _this.player.video.currentTime;
                        if (!bufferingDetected && currentPlayPos === lastPlayPos && !_this.player.video.paused) {
                            _this.player.container.classList.add('dplayer-loading');
                            bufferingDetected = true;
                        }
                        if (bufferingDetected && currentPlayPos > lastPlayPos && !_this.player.video.paused) {
                            _this.player.container.classList.remove('dplayer-loading');
                            bufferingDetected = false;
                        }
                        lastPlayPos = currentPlayPos;
                    }
                }, 100);
            }
        },
        {
            key: 'initprogressChecker',
            value: function initprogressChecker() {
                var _this2 = this;
                this.progressChecker = setInterval(function () {
                    if (_this2.enableprogressChecker) {
                        _this2.player.bar.set('played', _this2.player.video.currentTime / _this2.player.video.duration, 'width');
                        var currentTime = _utils2.default.secondToTime(_this2.player.video.currentTime);
                        if (_this2.player.template.ptime.innerHTML !== currentTime) {
                            _this2.player.template.ptime.innerHTML = _utils2.default.secondToTime(_this2.player.video.currentTime);
                        }
                    }
                }, 100);
            }
        },
        {
            key: 'initfpsChecker',
            value: function initfpsChecker() {
                var _this3 = this;
                window.requestAnimationFrame(function () {
                    if (_this3.enablefpsChecker) {
                        _this3.initfpsChecker();
                        if (!_this3.fpsStart) {
                            _this3.fpsStart = new Date();
                            _this3.fpsIndex = 0;
                        } else {
                            _this3.fpsIndex++;
                            var fpsCurrent = new Date();
                            if (fpsCurrent - _this3.fpsStart > 1000) {
                                _this3.player.infoPanel.fps(_this3.fpsIndex / (fpsCurrent - _this3.fpsStart) * 1000);
                                _this3.fpsStart = new Date();
                                _this3.fpsIndex = 0;
                            }
                        }
                    } else {
                        _this3.fpsStart = 0;
                        _this3.fpsIndex = 0;
                    }
                });
            }
        },
        {
            key: 'initinfoChecker',
            value: function initinfoChecker() {
                var _this4 = this;
                this.infoChecker = setInterval(function () {
                    if (_this4.enableinfoChecker) {
                        _this4.player.infoPanel.update();
                    }
                }, 1000);
            }
        },
        {
            key: 'enable',
            value: function enable(type) {
                this['enable' + type + 'Checker'] = true;
                if (type === 'fps') {
                    this.initfpsChecker();
                }
            }
        },
        {
            key: 'disable',
            value: function disable(type) {
                this['enable' + type + 'Checker'] = false;
            }
        },
        {
            key: 'destroy',
            value: function destroy(type) {
                this[type + 'Checker'] && clearInterval(this[type + 'Checker']);
            }
        }
    ]);
    return Time;
}();
exports.default = Time;


//////////////////
// WEBPACK FOOTER
// ./src/js/time.js
// module id = 21
// module chunks = 0